import { render } from "./GeneralDataPage.vue?vue&type=template&id=dda75d44&scoped=true"
import script from "./GeneralDataPage.vue?vue&type=script&lang=js"
export * from "./GeneralDataPage.vue?vue&type=script&lang=js"

import "./GeneralDataPage.vue?vue&type=style&index=0&id=dda75d44&scoped=true&lang=css"

import exportComponent from "C:\\Projekte\\repos\\datentool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dda75d44"]])

export default __exports__